export const AddressTypeTypes = {
  developer: "developer",
  OPERATING: "OPERATING",
  REGIONAL: "REGIONAL",
} as const;

export type AddressTypeEnum = (typeof AddressTypeTypes)[keyof typeof AddressTypeTypes];

export const generateAddressTypeName = (type: string): string => {
  const translationMap: Record<AddressTypeEnum, string> = {
    [AddressTypeTypes.developer]: "Застройщик",
    [AddressTypeTypes.OPERATING]: "Эксплуатирующая организация",
    [AddressTypeTypes.REGIONAL]: "Региональный оператор",
  };

  if (type in translationMap) {
    return translationMap[type as AddressTypeEnum];
  }

  return type;
};
